import { FEATURES, MODULES } from '../constants/template-info'
import { LocalStorageData } from '../domains/contentful/LocalStorageDataWithExpiry'

import isBrowser from './isBrowser'
import { captureException } from './sentryUtil'

export const setInLocalStorageWithExpiry = (key: string, value: string, expiryInMinutes?: number) => {
  if (!isBrowser()) return
  try {
    const now = new Date()
    // @i18n-ignore
    const MAX_EXPIRY_DATE_IN_EPOCH_MILLESECONDS = new Date('Fri, 18 May 2035 12:00:00 UTC').getTime()
    const data: LocalStorageData = {
      key: key,
      value: value,
      expiryInMs: expiryInMinutes ? now.getTime() + expiryInMinutes * 60 * 1000 : MAX_EXPIRY_DATE_IN_EPOCH_MILLESECONDS,
    }
    console.log('Setting key value in local storage with expiry : ', data)

    localStorage.setItem(key, JSON.stringify(data))
  } catch (error) {
    console.info('setInLocalStorageWithExpiry error', error, key, value)
    captureException('setInLocalStorageWithExpiry error', {
      module: MODULES.LOCAL_STORAGE,
      feature: FEATURES.SET_IN_LOCAL_STORAGE_WITH_EXPIRY,
      extraInfo: {
        // @i18n-ignore
        capturedFrom: 'Set in local storage with expiry function',
        localStorageKey: key,
        localStorageValue: value,
        errorDetail: JSON.stringify(error),
      },
    })
  }
}
